module.exports = "/_next/static/images/odontoMobile-2b53e5a0e14f2b3afaf042fb1adde91a.svg";